// extracted by mini-css-extract-plugin
module.exports = {"check-box":"check-box__1zxSt","selected":"selected__2LiFg","check-box-inner":"check-box-inner__2rHgW"};